import { MultiContextProvider } from "~/contexts/MultiContext"
import { Multi } from "~/components/Multi"

export default function Watch() {
  return (
    <MultiContextProvider>
      <Multi />
    </MultiContextProvider>
  )
}
